(() => {
  const config = document.currentScript;
  if (!config || window.Shopify?.designMode) return;

  const key = 'seremori:comic-login-started';
  const maxAge = 15 * 60 * 1000;
  const comicsPath = config.dataset.comicsPath;
  const normalizedPath = path => path.replace(/\/$/, '');

  try {
    const pending = sessionStorage.getItem(key);
    if (pending !== null) {
      const age = Date.now() - Number(pending);
      if (!pending.trim() || !Number.isFinite(age) || age < 0 || age > maxAge) {
        sessionStorage.removeItem(key);
      } else if (config.hasAttribute('data-customer')) {
        sessionStorage.removeItem(key);
        if (config.hasAttribute('data-homepage')) {
          window.location.replace(`${comicsPath}#share-your-story`);
          return;
        }
      }
    }
  } catch {}

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    try {
      const login = new URL(link.href, window.location.origin);
      if (login.origin !== window.location.origin || !login.pathname.endsWith('/customer_authentication/login')) return;
      const returnTo = login.searchParams.get('return_to');
      const destination = returnTo ? new URL(returnTo, window.location.origin) : null;
      if (normalizedPath(window.location.pathname) === normalizedPath(comicsPath)
        && destination?.origin === window.location.origin
        && normalizedPath(destination.pathname) === normalizedPath(comicsPath)) {
        sessionStorage.setItem(key, String(Date.now()));
      } else {
        sessionStorage.removeItem(key);
      }
    } catch {}
  });
})();
